import { FC, useEffect, useRef, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import dynamic from 'next/dynamic'

import HeaderCartPopup from '../Popups/Cart/HeaderCartPopup'
import { selectCartProductsUnique, selectTotalCartQuantity } from '../Cart/selectors'
import { useCart } from '../Cart/CartProvider'
import useIsOnMobile from '../../services/useIsOnMobile'

import styles from '../../styles/MobileCartModal.module.less'
import cartPopupStyles from '../../styles/CartPopup.module.less'

const BaseModal = dynamic(() => import('../Modals/BaseModal'))

const MobileCartModal: FC = () => {
  const [showMobilePopover, setShowMobilePopover] = useState(false)

  const { cartState: { cart, isLoading } } = useCart()
  const isOnMobile = useIsOnMobile()
  const { t } = useTranslation('common')

  // Value -1 means data is not loaded yet
  const currentQuantityCount = useRef(-1)

  const cartProducts = cart ? selectCartProductsUnique(cart) : []
  const quantityCount = cart ? selectTotalCartQuantity(cart) : 0

  useEffect(() => {
    // Don't do anything if data is not loaded
    if (!cart?.included) {
      return () => {}
    }

    // Don't do anything on initial load and set current value when cart is loaded
    if (currentQuantityCount.current === -1 && !isLoading) {
      currentQuantityCount.current = quantityCount
      return () => {}
    }

    const hasTotalQuantityCountChanged = currentQuantityCount.current !== quantityCount

    if (quantityCount && hasTotalQuantityCountChanged) {
      currentQuantityCount.current = quantityCount
      setShowMobilePopover(true)
    }

    return () => {}
  }, [cartProducts, quantityCount])

  if (!isOnMobile || !showMobilePopover) {
    return null
  }

  return (
    <BaseModal
      closeModal={() => setShowMobilePopover(false)}
      isOpen={showMobilePopover}
      backdrop={false}
      size="sm"
      modalClassName={styles['mobile-cart-popover']}
      backdropClassName={styles['mobile-cart-popover-wrapper']}
      hideButtons
      title={(
        <h4>
          {t('cart:{{count}} products in cart', { count: cartProducts.length })}
        </h4>
          )}
    >
      <div
        className={`${cartPopupStyles['cart-popup']} ${cartPopupStyles['header-cart-popup']}`}
      >
        <HeaderCartPopup
          cart={cart}
          totalProductsInCart={cartProducts.length}
          products={cartProducts}
          displayTitle={false}
          closeModal={() => setShowMobilePopover(false)}
        />
      </div>
    </BaseModal>
  )
}

export default MobileCartModal
